import {openResourceModal} from '../../core/modalCommand';
import {
	ACS_SCHEDULE_CREATE_MODAL_EVENT,
	ACS_SCHEDULE_DELETE_MODAL_EVENT,
	ACS_SCHEDULE_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open the Add ACS Schedule form, with nothing filled in.
 *
 * This resource maps no fields: the agent opens the empty form and the
 * person completes it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAcsScheduleCreateModal(command, envelope) {
	return openResourceModal(ACS_SCHEDULE_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit ACS Schedule for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAcsScheduleEditModal(command, envelope) {
	return openResourceModal(ACS_SCHEDULE_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Delete ACS Schedule confirmation.
 *
 * The confirmation, not the deletion. Nothing is removed until the person
 * presses the button inside it, which is why this capability is declared
 * destructive rather than read: a read capability would be worked
 * automatically, and this one must not be.
 *
 * Canvas refuses some of these itself - a profile still attached to an
 * SSID or a Site cannot be deleted - and says so in its own words. That
 * refusal is left to Canvas rather than guessed at here.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAcsScheduleDeleteModal(command, envelope) {
	return openResourceModal(ACS_SCHEDULE_DELETE_MODAL_EVENT, command, envelope);
}
